var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
import { ReadonlyService } from '../../../../items/columns/readonly/readonly.service';
import { ConfigService } from '../../../../service/config.service';
var iframeCode = "\n    <!DOCTYPE html>\n    <html>\n    <head>\n      <meta http-equiv='content-type' content='text/html; charset=utf-8'/>\n      <title>\u5730\u56F3\u8868\u793A</title>\n      <script type='text/javascript' src='//{{authHost}}/v2/jslib/js/map/mfjsapi'></script>\n      <script type='text/javascript'>\n\n        var appid = '{{appid}}';\n        var mapHost = '{{mapHost}}';\n        var srchHost = '{{srchHost}}';\n        var mapId = '{{mapId}}';\n\n        // \u8A8D\u8A3C\u51E6\u7406\u3068\u5730\u56F3API\u30B5\u30FC\u30D0\u8A2D\u5B9A\n        window.onload = function () {\n          // \u30B5\u30FC\u30D0\u540D\u8A2D\u5B9A\n          Mfapi.mapHost = mapHost;\n          // \u8A8D\u8A3C\u30EA\u30AF\u30A8\u30B9\u30C8\n          Mfapi.auth(appid, task_func);\n        };\n\n        // \u8A8D\u8A3C\u5F8C\u30B3\u30FC\u30EB\u30D0\u30C3\u30AF\u95A2\u6570\n        function task_func(authStatus) {\n          if (authStatus != 'success') {\n            var event = new CustomEvent('iframeAuthError', {detail: {status: authStatus}});\n            parent.document.body.dispatchEvent(event);\n            return;\n          }\n          // \u5730\u56F3\u4F5C\u6210\n          Mfapi.mapCreate(mapId, {mapScale: 16});\n          // \u30DE\u30FC\u30AB\u30FC\u30EC\u30A4\u30E4\u30FC\u4F5C\u6210\u51E6\u7406\n          Mfapi.Map.addMarkerLayer('mLayer');\n          // \u4F4F\u6240\u691C\u7D22\n          searchAddr();\n        }\n\n        // \u4F4F\u6240\u691C\u7D22API\n        function searchAddr() {\n          var apiname = '/v1/addr';\n          var param1 = 'key=' + encodeURIComponent(Mfapi.getAuthAccessKey());\n          var param2 = 'addr=' + addr;\n          var param3 = 'callback=responseAddr';\n          var reqUrl = '//' + srchHost + apiname + '?' + param1 + '&' + param2 + '&' + param3;\n\n          // API\u5B9F\u884C\n          var scrpJsonp = document.createElement('script');\n          scrpJsonp.setAttribute('type', 'text/javascript');\n          scrpJsonp.setAttribute('charset', 'utf-8');\n          scrpJsonp.setAttribute('src', reqUrl);\n          var head = document.getElementsByTagName('head').item(0);\n          head.appendChild(scrpJsonp);\n        }\n\n        // \u4F4F\u6240\u691C\u7D22API\u306E\u30B3\u30FC\u30EB\u30D0\u30C3\u30AF\u95A2\u6570\n        function responseAddr(data) {\n          if (data.status != 'success' || !data.results || data.results.length == 0) {\n            var event = new CustomEvent('iframeSearchAddrError', {detail: data});\n            parent.document.body.dispatchEvent(event);\n            return;\n          }\n\n          var result = data.results[0];\n\n          // \u5730\u56F3\u4E2D\u5FC3\u5EA7\u6A19\u3001\u5730\u56F3\u30B9\u30B1\u30FC\u30EB\u60C5\u5831\u8A2D\u5B9A\n          var center = new Mfapi.Util.LonLat(result.lon, result.lat);\n          Mfapi.Map.setCenterPosition(center);\n          Mfapi.Map.setMapScale(16);\n\n          // \u30DE\u30FC\u30AB\u30FC\u4F5C\u6210\n          Mfapi.Map.MarkerLayer['mLayer'].removeAll();\n          var featureId = 'marker_1';\n          var options = {\n            position: new Mfapi.Util.LonLat(result.lon, result.lat)\n          };\n          Mfapi.Map.MarkerLayer['mLayer'].addMarker(options, featureId);\n        }\n      </script>\n    </head>\n    <body>\n    <!--\u5730\u56F3DIV\u30BF\u30B0-->\n    <div id='{{mapId}}' style=\"width: 100%; height: 480px;\"></div>\n    </body>\n    </html>\n";
var KtsMapComponent = /** @class */ (function (_super) {
    __extends(KtsMapComponent, _super);
    function KtsMapComponent(router, route, logger, action, message, page, service, readonlyService, config, document) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.readonlyService = readonlyService;
        _this.config = config;
        _this.document = document;
        _this.appid = _this.config.config['map_appid'] || ''; // 認証ID
        _this.env = _this.config.config['map_environment'] || ''; // 'test' or 'prod'
        _this.content = iframeCode;
        _this.addr = '';
        _this.err = '';
        _this.disp = false;
        _this.toggle = true; // 地図の表示／非表示
        return _this;
    }
    KtsMapComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.document.body.addEventListener('iframeAuthError', function (d) {
            _this.err = _this.msgSnapshot['au.COMPONENT.KtsMapComponent.error.auth'];
            _this.disp = false;
            _this.logger.error(d.detail.status);
        });
        this.document.body.addEventListener('iframeSearchAddrError', function (d) {
            _this.err = _this.msgSnapshot['au.COMPONENT.KtsMapComponent.error.searchAddr'];
            _this.logger.error(d.detail.status);
        });
        this.actionText = this.msgSnapshot['au.COMPONENT.KtsMapComponent.label.closeMap'];
    };
    KtsMapComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    KtsMapComponent.prototype.onSubscribe = function (data) {
        if (typeof data === 'undefined') {
            return;
        }
        this.addr = '';
        this.setAddrs(this.cols, data);
        if (this.addr) {
            if (this.disp) {
                this.searchAddr();
            }
            else {
                this.setIframe();
            }
        }
    };
    KtsMapComponent.prototype.onEvent = function (e1, e2, r) {
    };
    KtsMapComponent.prototype.switchToggle = function () {
        this.toggle = !this.toggle;
        this.actionText = this.toggle
            ? this.msgSnapshot['au.COMPONENT.KtsMapComponent.label.closeMap']
            : this.msgSnapshot['au.COMPONENT.KtsMapComponent.label.openMap'];
    };
    KtsMapComponent.prototype.setAddrs = function (cols, data) {
        for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
            var col = cols_1[_i];
            if (col.items) {
                for (var _a = 0, _b = col.items; _a < _b.length; _a++) {
                    var item = _b[_a];
                    this.addr += this.readonlyService.getValue(this.componentName, item, data[col.key], 'label');
                }
            }
            else {
                this.addr += this.readonlyService.getValue(this.componentName, col, data[col.key], 'label');
            }
        }
    };
    KtsMapComponent.prototype.setIframe = function () {
        this.disp = true;
        this.err = '';
        this.content = this.content.replace(/\{\{appid\}\}/g, this.appid);
        this.content = this.content.replace(/\{\{authHost\}\}/g, this.getHost('auth'));
        this.content = this.content.replace(/\{\{mapHost\}\}/g, this.getHost('map'));
        this.content = this.content.replace(/\{\{srchHost\}\}/g, this.getHost('srch'));
        this.content = this.content.replace(/\{\{mapId\}\}/g, this.componentName + '#Map');
        var win = this.iframe.nativeElement.contentWindow;
        win['addr'] = this.addr;
        var doc = win.document;
        doc.open();
        doc.write(this.content);
        doc.close();
    };
    KtsMapComponent.prototype.getHost = function (key) {
        return 'api-' + key + (this.env === 'prod' ? '' : '-pre') + '.mapfan.com';
    };
    KtsMapComponent.prototype.searchAddr = function () {
        var win = this.iframe.nativeElement.contentWindow;
        win['addr'] = this.addr;
        win['searchAddr']();
    };
    KtsMapComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-map',
                    template: "<div id=\"{{ componentName }}\">\n  <div class=\"filter\">\n    <p *ngIf=\"disp\" class=\"filter_trigger\">\n      <span [class.open]=\"toggle\" (click)=\"switchToggle()\">{{ actionText }}</span>\n    </p>\n    <div class=\"filter_property_toggle -p-1\" [style.display]=\"toggle ? 'block': 'none'\">\n      <p *ngIf=\"err\" class=\"formError\">{{ err }}</p>\n      <p *ngIf=\"addr\">{{ addr }}</p>\n      <iframe frameborder=\"1\" width=\"100%\" height=\"500px\" #iframe [style.display]=\"addr ? 'block': 'none'\"></iframe>\n    </div>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    KtsMapComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService },
        { type: ReadonlyService },
        { type: ConfigService },
        { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
    ]; };
    KtsMapComponent.propDecorators = {
        iframe: [{ type: ViewChild, args: ['iframe',] }]
    };
    return KtsMapComponent;
}(ContentBaseComponent));
export { KtsMapComponent };
//# sourceMappingURL=map.component.js.map